<style lang="less" scoped>
.header-left {
  width: 300px;
}
.header-middle {
  flex: 1;
  text-align: center;
}
.header-right {
  width: 300px;
}
.dealer-header div {
  margin-bottom: 10px; // text-align: center;
}
.text-center {
  justify-content: center;
}
.title {
  text-align: left;
}
.tec-content {
  justify-content: space-around;
  height: 50px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 50px;
}
.space-between {
  margin: 10px;
  justify-content: space-between;
}
.finance-report-child-div {
  width: 232px;
  height: 245px;
  background: #ffffff;
  box-shadow: 0px -1px 16px 0px rgba(42, 42, 68, 0.1);
  border-radius: 22px;
  margin-right: 30px;
}
.report-header-div {
  height: 16px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #8f9bb3;
  line-height: 16px;
  padding: 20px 0 83px 30px;
}
.report-mes-div {
  margin-bottom: 20px;
}
.report-mes-div div {
  padding-left: 30px;
  height: 32px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 32px;
}
.report-mes-title {
  margin-right: 16px;
}
.report-btn {
  width: 100px;
  height: 30px;
}
.line-title {
  width: 10%;
  font-size: 14px;
  text-align: center;
  padding-top: 50px;
}
.report-table {
  font-family: verdana, arial, sans-serif;
  font-size: 14px;
  color: #333333;
  border-width: 1px;
  border-color: #666666;
  border-collapse: collapse;
}
.report-table td {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #666666;
  text-align: center;
}
.title {
  height: 44px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 22px;
}
.btn-title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #bb87f3;
}
.topic-title {
  height: 33px;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 33px;
  margin-bottom: 30px;
}
</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb
        :bConfigList="pageConfig.detailBreadCrumb"
      ></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">运营商详情</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <div class="flex title">
          <div class="flex-1">
            <span>运营商：</span>
          </div>
          <div class="flex-1">
            {{ dealerInfo.dealerNanme }}
          </div>
          <div class="flex-1">
            <span>运营商合作协议：</span>
          </div>
          <div class="flex-1">
            <a
              class="btn-title"
              :href="dealerInfo.fileAttach"
              :download="dealerInfo.fileAttachName"
              v-if="dealerInfo.fileAttach != '/api/v1'"
              >合作协议下载</a
            >
            <span v-else>合作协议下载</span>
          </div>
        </div>
        <div class="flex title">
          <div class="flex-1">
            <span>公司联系人：</span>
          </div>
          <div class="flex-1">
            {{ dealerInfo.contactName }}
          </div>
          <div class="flex-1">
            <span>合作协议概述：</span>
          </div>
          <div class="flex-1">
            <el-tooltip
              v-if="flag"
              class="item"
              effect="dark"
              :content="contactSummary"
              placement="bottom"
            >
              <div>{{ shortContactSummary }}</div>
            </el-tooltip>
            <div v-else class="title">{{ dealerInfo.contactSummary }}</div>
          </div>
        </div>
        <div class="flex title">
          <div class="flex-1">
            <span>联系人职务：</span>
          </div>
          <div class="flex-1">
            {{ dealerInfo.contactPosition }}
          </div>
          <div class="flex-1">
            <span>运营商备注：</span>
          </div>
          <div class="flex-1">
            <el-tooltip
              v-if="remarkFlag"
              class="item"
              effect="dark"
              :content="dealerRemark"
              placement="bottom"
            >
              <div>{{ shortDealerRemark }}</div>
            </el-tooltip>
            <div v-else>{{ dealerInfo.dealerRemark }}</div>
          </div>
        </div>
        <div class="flex title">
          <div class="flex-1">
            <span>公司电话：</span>
          </div>
          <div class="flex-1">
            {{ dealerInfo.contactPhone }}
          </div>
          <div class="flex-1">
            <span>创建时间：</span>
          </div>
          <div class="flex-1">
            {{ dealerInfo.createdWhen }}
          </div>
        </div>
        <div class="flex title">
          <div class="flex-1">
            <span>社会统一组织机构代码：</span>
          </div>
          <div class="flex-1 ">
            {{ dealerInfo.organizeNo }}
          </div>
          <div class="flex-1"></div>
          <div class="flex-1"></div>
        </div>
        <el-divider></el-divider>
        <div>
          <div class="topic-title">设备概要</div>
          <div class="flex tec-content">
            <div><span>电站数量：</span>{{ dealerInfo.stationCount }}</div>
            <div><span>电桩数量：</span>{{ dealerInfo.pileCount }}</div>
            <div><span>离网：</span>{{ dealerInfo.offLineCount }}</div>
            <div><span>故障：</span>{{ dealerInfo.errorCount }}</div>
            <div><span>申请维修：</span>{{ dealerInfo.repairCount }}</div>
          </div>
        </div>
        <el-divider></el-divider>
        <div>
          <div class="topic-title">财务报表</div>
          <div class="flex">
            <div class="finance-report-child-div">
              <div class="report-header-div">提现</div>
              <div class="report-mes-div">
                <div>
                  <span class="report-mes-title">待提现金额：</span
                  >{{ detailForm.unCashOutFee }}元
                </div>
                <div>
                  <span class="report-mes-title">已提现金额：</span
                  >{{ detailForm.cashOutedFee }}元
                </div>
                <div>
                  <span class="report-mes-title">未入账金额：</span
                  >{{ detailForm.uncheckFee }}元
                </div>
              </div>
            </div>
            <div class="finance-report-child-div">
              <div class="report-header-div">合计订单总览</div>
              <div class="report-mes-div">
                <div>
                  <span class="report-mes-title">订单收入：</span
                  >{{ detailForm.actFeeAll }}元
                </div>
                <div>
                  <span class="report-mes-title">充电量：</span
                  >{{ detailForm.chargeValAll }}kW·h
                </div>
                <div>
                  <span class="report-mes-title">订单量：</span
                  >{{ detailForm.orderCountAll }}单
                </div>
              </div>
            </div>
            <div class="finance-report-child-div">
              <div class="report-header-div">桩到家订单（线上订单）</div>
              <div class="report-mes-div">
                <div>
                  <span class="report-mes-title">订单收入：</span
                  >{{ detailForm.actFeeOnLine }}元
                </div>
                <div>
                  <span class="report-mes-title">充电量：</span
                  >{{ detailForm.chargeValOnLine }}kW·h
                </div>
                <div>
                  <span class="report-mes-title">订单量：</span
                  >{{ detailForm.orderCountOnLine }}单
                </div>
              </div>
            </div>
            <div class="finance-report-child-div">
              <div class="report-header-div">自营订单（线下订单）</div>
              <div class="report-mes-div">
                <div>
                  <span class="report-mes-title">订单收入：</span
                  >{{ detailForm.actFeeOffLine }}元
                </div>
                <div>
                  <span class="report-mes-title">充电量：</span
                  >{{ detailForm.chargeValOffLine }}kW·h
                </div>
                <div>
                  <span class="report-mes-title">订单量：</span
                  >{{ detailForm.orderCountOffLine }}单
                </div>
              </div>
            </div>
            <div class="finance-report-child-div">
              <div class="report-header-div">客户金额</div>
              <div class="report-mes-div">
                <div>
                  <span class="report-mes-title">客户消费金额：</span
                  >{{ detailForm.custConsume }}元
                </div>
                <div>
                  <span class="report-mes-title">客户度电消费：</span
                  >{{ detailForm.allChargeElectric }}度
                </div>
                <div>
                  <span class="report-mes-title">累计客户度电：</span
                  >{{ detailForm.allAddElectric }}度
                </div>
              </div>
            </div>
            <div class="finance-report-child-div">
              <div class="report-header-div">平台服务费</div>
              <div class="report-mes-div">
                <div>
                  <span class="report-mes-title">服务费：</span
                  >{{ detailForm.serviceFee }}元
                </div>
                <div>
                  <span class="report-mes-title">服务费减免（已使用）：</span
                  >{{ detailForm.serviceFreeFee }}元
                </div>
                <div>
                  <span class="report-mes-title">服务费减免（未使用）：</span
                  >{{ detailForm.serviceUnFreeFee }}元
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-divider></el-divider>
        <div>
          <div class="flex" style="margin-bottom:10px;line-height:30px;">
            <div>经营状况</div>
            <div class="flex-1"></div>
            <div class="flex">
              <!-- <el-button class="report-btn" size="small">今日</el-button> -->
              <el-button
                class="report-btn"
                size="small"
                @click="getDayTableData()"
                >近七日</el-button
              >
              <el-button
                class="report-btn"
                size="small"
                @click="getMonthTableData()"
                >本月</el-button
              >
              <el-button
                class="report-btn"
                size="small"
                @click="getAllTableData()"
                >本年度</el-button
              >
            </div>
          </div>
          <table class="report-table" width="100%">
            <tr>
              <td></td>
              <td>合计订单（元）</td>
              <td>桩到家订单（元）</td>
              <td>自营订单（元）</td>
              <td>充电量（kW·h)</td>
              <td>用户量（人）</td>
              <td>订单量（单）</td>
              <td>服务费（元）</td>
              <td>实际收入（元）</td>
            </tr>
            <tr>
              <td>本期</td>
              <td>{{ thisData.actFeeAll }}</td>
              <td>{{ thisData.actFeeOnLine }}</td>
              <td>{{ thisData.actFeeOffLine }}</td>
              <td>{{ thisData.chargeValAll }}</td>
              <td>{{ thisData.custCount }}</td>
              <td>{{ thisData.orderCountAll }}</td>
              <td>{{ thisData.serviceFeeAll }}</td>
              <td>{{ thisData.actInComeAll }}</td>
            </tr>
            <tr>
              <td>上期</td>
              <td>{{ lastData.actFeeAll }}</td>
              <td>{{ lastData.actFeeOnLine }}</td>
              <td>{{ lastData.actFeeOffLine }}</td>
              <td>{{ lastData.chargeValAll }}</td>
              <td>{{ lastData.custCount }}</td>
              <td>{{ lastData.orderCountAll }}</td>
              <td>{{ lastData.serviceFeeAll }}</td>
              <td>{{ lastData.actInComeAll }}</td>
            </tr>
            <tr>
              <td>变化趋势</td>
              <td>{{ trendData.actFeeAll }}%</td>
              <td>{{ trendData.actFeeOnLine }}%</td>
              <td>{{ trendData.actFeeOffLine }}%</td>
              <td>{{ trendData.chargeValAll }}%</td>
              <td>{{ trendData.custCount }}%</td>
              <td>{{ trendData.orderCountAll }}%</td>
              <td>{{ trendData.serviceFeeAll }}%</td>
              <td>{{ trendData.actInComeAll }}%</td>
            </tr>
          </table>
        </div>
        <el-divider></el-divider>
        <div>
          <div class="flex">
            <div class="flex-1"></div>
            <el-select
              v-model="lineData.sourseType"
              placeholder="请选择"
              size="small"
              style="margin-right:10px;"
            >
              <el-option
                v-for="(item, index) in sourseTypeArr"
                :label="item.name"
                :value="item.value"
                :key="index"
                @click.native="getLineData()"
              ></el-option>
            </el-select>
            <el-button
              class="report-btn"
              size="small"
              @click="getOtherLineData(7)"
              >近七日</el-button
            >
            <el-button
              class="report-btn"
              size="small"
              @click="getOtherLineData(30)"
              >本月</el-button
            >
            <el-button
              class="report-btn"
              size="small"
              @click="getOtherLineData(365)"
              >本年度</el-button
            >
          </div>
          <div class="flex">
            <div class="line-title">
              {{ lineTitle }}订单金额<br /><br />{{ feeSum }}元
            </div>
            <echarts-line
              v-if="otherFlag"
              :lineId="orderAmount"
              :yUnit="unit.yuan"
              :data="orderFee"
            ></echarts-line>
          </div>
          <!-- <div class="flex">
            <div class="flex-1"></div>
            <el-button
              class="report-btn"
              size="small"
              @click="getOtherLineData(7)"
              >近七日</el-button
            >
            <el-button
              class="report-btn"
              size="small"
              @click="getOtherLineData(30)"
              >本月</el-button
            >
            <el-button
              class="report-btn"
              size="small"
              @click="getOtherLineData(365)"
              >本年度</el-button
            >
          </div> -->
          <div class="flex">
            <div class="line-title">
              {{ lineTitle }}充电量<br /><br />{{ chargeNum }}kW
            </div>
            <echarts-line
              v-if="otherFlag"
              :lineId="chargingCapacity"
              :yUnit="unit.kW"
              :data="chargeSum"
            ></echarts-line>
          </div>
          <!-- <div class="flex">
            <div class="flex-1"></div>
            <el-select
              v-model="lineData.sourseType"
              placeholder="请选择"
              size="small"
              style="margin-right:10px;"
            >
              <el-option label="合计订单" value="00"></el-option>
              <el-option label="桩到家订单（线上订单）" value="02"></el-option>
              <el-option label="自营订单（线下订单）" value="01"></el-option>
            </el-select>
            <el-button
              class="report-btn"
              size="small"
              @click="getOtherLineData(7)"
              >近七日</el-button
            >
            <el-button
              class="report-btn"
              size="small"
              @click="getOtherLineData(30)"
              >本月</el-button
            >
            <el-button
              class="report-btn"
              size="small"
              @click="getOtherLineData(365)"
              >本年度</el-button
            >
          </div> -->
          <div class="flex">
            <div class="line-title">
              {{ lineTitle }}订单量<br /><br />{{ orderSum }}单
            </div>
            <echarts-line
              v-if="otherFlag"
              :lineId="orderQuantity"
              :yUnit="unit.dan"
              :data="orderNum"
            ></echarts-line>
          </div>
          <!-- <div class="flex">
            <div class="flex-1"></div>
            <el-button
              class="report-btn"
              size="small"
              @click="getCustLineData(0)"
              >近七日</el-button
            >
            <el-button
              class="report-btn"
              size="small"
              @click="getCustLineData(1)"
              >本月</el-button
            >
            <el-button
              class="report-btn"
              size="small"
              @click="getCustLineData(2)"
              >本年度</el-button
            >
          </div> -->
          <div class="flex">
            <div class="line-title">
              {{ lineTitle }}充电用户<br /><br />{{ custSum }}人
            </div>
            <echarts-line
              v-if="otherFlag"
              :lineId="chargingUser"
              :yUnit="unit.ren"
              :data="custNum"
            ></echarts-line>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
import echartsLine from './echarts-line'
export default {
  components: {
    echartsLine,
  },
  data() {
    return {
      pageConfig,
      editFlag: false, //是否编辑模式
      // 默认值设置
      detailForm: {},
      lineTitle: '近七日', // echart图名称
      custLineTitle: '近七日', //未使用
      orderAmount: 'orderAmount', // 对应echart图的ID
      chargingCapacity: 'chargingCapacity', // 对应echart图的ID
      orderQuantity: 'orderQuantity', // 对应echart图的ID
      chargingUser: 'chargingUser', // 对应echart图的ID
      unit: {
        //单位
        yuan: '元',
        kW: 'kW·h',
        dan: '单',
        ren: '人',
      },
      orderFee: {
        //本年度订单金额数据
        xAxis: [],
        thisData: [],
        lastData: [],
      },
      chargeSum: {
        //本年度充电量
        xAxis: [],
        thisData: [],
        lastData: [],
      },
      orderNum: {
        //本年度订单量
        xAxis: [],
        thisData: [],
        lastData: [],
      },
      custNum: {
        //充电用户
        xAxis: [],
        thisData: [],
        lastData: [],
      },
      flag: false, //合作协议内容是否显示
      remarkFlag: false, //运行商备注是否显示
      otherFlag: false, //控制echart图是否显示
      lineData: {
        sourseType: '00', // 初始化订单种类
      },
      lastData: {}, //经营状况表格上期
      thisData: {}, //经营状况表格本期
      trendData: {}, //经营状况表格变化趋势
      dealerInfo: {}, //	运营商详情对象
      detailTableData: {}, //	表单数据详情Echatrs图数据
      contactSummary: '', //合作协议提示文字
      shortContactSummary: '', //合作协议内容
      dealerRemark: '', //运营商备注提示文字
      shortDealerRemark: '', //运营商备注内容信息
      //订单数据
      sourseTypeArr: [
        {
          name: '合计订单',
          value: '00',
        },
        {
          name: '桩到家订单（线上订单）',
          value: '02',
        },
        {
          name: '自营订单（线下订单）',
          value: '01',
        },
      ],
      feeSum: 0, //订单金额
      chargeNum: 0, //充电量
      orderSum: 0, //订单量
      custSum: 0, //充电用户数量
    }
  },
  methods: {
    init() {
      if (this.$store.state.editId) {
        this.editFlag = true
        this.getFormInfo()
        this.getDealerInfo()
        this.getOtherLineData(7)
      }
    },
    // 获取表单信息
    getFormInfo() {
      let _ = this
      let obj = {}
      obj.dealerNo = _.$store.state.editId //'DEAL1543895439624';
      _.$U.showLoading(_)
      _.$H.post(_, _.$A.dealer.rpt, obj).then((res) => {
        _.detailForm = res.data.data
        _.detailForm.unCashOutFee = _.detailForm.unCashOutFee.toFixed(2)
        _.detailForm.uncheckFee = _.detailForm.uncheckFee.toFixed(2)
        _.detailForm.actFeeAll = _.detailForm.actFeeAll.toFixed(2)
        _.detailForm.chargeValAll = _.detailForm.chargeValAll.toFixed(2)
        _.detailForm.orderCountAll = _.detailForm.orderCountAll.toFixed(2)
        _.detailForm.actFeeOnLine = _.detailForm.actFeeOnLine.toFixed(2)
        _.detailForm.chargeValOnLine = _.detailForm.chargeValOnLine.toFixed(2)
        _.detailForm.orderCountOnLine = _.detailForm.orderCountOnLine.toFixed(2)
        _.detailForm.custConsume = _.detailForm.custConsume.toFixed(2)
        _.detailForm.custBalance = _.detailForm.custBalance.toFixed(2)
        _.detailForm.custChargeMoney = _.detailForm.custChargeMoney.toFixed(2)
        _.detailForm.serviceFee = _.detailForm.serviceFee.toFixed(2)
        _.detailForm.serviceFreeFee = _.detailForm.serviceFreeFee.toFixed(2)
        _.detailForm.serviceUnFreeFee = _.detailForm.serviceUnFreeFee.toFixed(2)
        _.detailForm.actFeeOffLine = _.detailForm.actFeeOffLine.toFixed(2)
        _.detailForm.chargeValOffLine = _.detailForm.chargeValOffLine.toFixed(2)
        _.detailForm.orderCountOffLine = _.detailForm.orderCountOffLine.toFixed(
          2
        )
        _.$U.hideLoading(_)
      })
      _.$H.post(_, _.$A.dealer.rptform, obj).then((res) => {
        _.detailTableData = res.data.data
        _.thisData = _.detailTableData.data7Day.thisData
        _.lastData = _.detailTableData.data7Day.lastData
        _.trendData = _.detailTableData.data7Day.trendData
        _.$U.hideLoading(_)
      })
    },
    //获取运营商详情
    getDealerInfo() {
      let _ = this
      let obj = {}
      obj.dealerNo = _.$store.state.editId
      _.$U.showLoading(_)
      _.$H.post(_, _.$A.dealer.rptinfo, obj).then((res) => {
        _.dealerInfo = res.data.data
        _.dealerInfo.fileAttach = '/api/v1' + _.dealerInfo.fileAttach
        _.contactSummary = _.dealerInfo.contactSummary
        if (_.dealerInfo.contactSummary.length > 17) {
          _.shortContactSummary =
            _.dealerInfo.contactSummary.substring(0, 15) + '...'
          this.flag = true
        } else {
          this.flag = false
        }
        _.dealerRemark = _.dealerInfo.dealerRemark
        if (_.dealerInfo.dealerRemark.length > 17) {
          _.shortDealerRemark =
            _.dealerInfo.dealerRemark.substring(0, 15) + '...'
          this.remarkFlag = true
        } else {
          this.remarkFlag = false
        }
        _.$U.hideLoading(_)
      })
    },
    //获取经营状况表格 7日数据
    getDayTableData() {
      let _ = this
      _.thisData = _.detailTableData.data7Day.thisData
      _.lastData = _.detailTableData.data7Day.lastData
      _.trendData = _.detailTableData.data7Day.trendData
    },
    //获取经营状况表格 本月数据
    getMonthTableData() {
      let _ = this
      _.thisData = _.detailTableData.dataMonth.thisData
      _.lastData = _.detailTableData.dataMonth.lastData
      _.trendData = _.detailTableData.dataMonth.trendData
    },
    //获取经营状况表格 本年度数据
    getAllTableData() {
      let _ = this
      _.thisData = _.detailTableData.dataAll.thisData
      _.lastData = _.detailTableData.dataAll.lastData
      _.trendData = _.detailTableData.dataAll.trendData
    },
    //获取echarts图标折现图数据
    getOtherLineData(chartDateType) {
      let _ = this
      if (chartDateType == 7) {
        _.lineTitle = '近七日'
        _.lineData.dealerNo = _.$store.state.editId //'DEAL1543895439624'
        _.lineData.chartDateType = chartDateType
        _.$U.showLoading(_)
        _.otherFlag = false
        _.orderFee.thisData = []
        _.chargeSum.thisData = []
        _.orderNum.thisData = []
        _.orderFee.xAxis = []
        _.chargeSum.xAxis = []
        _.orderNum.xAxis = []
        _.orderFee.lastData = []
        _.chargeSum.lastData = []
        _.orderNum.lastData = []
        _.custNum.thisData = []
        _.custNum.xAxis = []
        _.custNum.lastData = []
        _.feeSum = ''
        _.chargeNum = ''
        _.orderSum = ''
        _.custSum = ''
        _.$H.post(_, _.$A.dealer.rptchart, _.lineData).then((res) => {
          _.feeSum = res.data.data.feeSum
          _.chargeNum = res.data.data.chargeSum
          _.orderSum = res.data.data.orderNum
          _.custSum = res.data.data.custNum
          res.data.data.rptChartMap.thisData.forEach((item, index) => {
            _.orderFee.thisData.push(item.actFee)
            _.orderFee.xAxis.push(item.chargeDay)
            _.chargeSum.thisData.push(item.chargeVal)
            _.chargeSum.xAxis.push(item.chargeDay)
            _.orderNum.thisData.push(item.orderCount)
            _.orderNum.xAxis.push(item.chargeDay)
            _.custNum.thisData.push(item.custCount)
            _.custNum.xAxis.push(item.chargeDay)
          })
          res.data.data.rptChartMap.lastData.forEach((item, index) => {
            _.orderFee.lastData.push(item.actFee)
            _.chargeSum.lastData.push(item.chargeVal)
            _.orderNum.lastData.push(item.orderCount)
            _.custNum.lastData.push(item.custCount)
          })
          _.otherFlag = true
          _.$U.hideLoading(_)
        })
      } else if (chartDateType == 30) {
        _.lineTitle = '本月'
        _.lineData.dealerNo = _.$store.state.editId //'DEAL1543895439624'
        _.lineData.chartDateType = chartDateType
        _.$U.showLoading(_)
        _.otherFlag = false
        _.orderFee.thisData = []
        _.chargeSum.thisData = []
        _.orderNum.thisData = []
        _.orderFee.xAxis = [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
        ]
        _.chargeSum.xAxis = [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
        ]
        _.orderNum.xAxis = [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
        ]
        _.orderFee.lastData = []
        _.chargeSum.lastData = []
        _.orderNum.lastData = []
        _.custNum.thisData = []
        _.custNum.xAxis = [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
        ]
        _.custNum.lastData = []
        _.feeSum = ''
        _.chargeNum = ''
        _.orderSum = ''
        _.custSum = ''
        _.$H.post(_, _.$A.dealer.rptchart, _.lineData).then((res) => {
          _.feeSum = res.data.data.feeSum
          _.chargeNum = res.data.data.chargeSum
          _.orderSum = res.data.data.orderNum
          _.custSum = res.data.data.custNum
          res.data.data.rptChartMap.thisData.forEach((item, index) => {
            _.orderFee.thisData.push(item.actFee)
            //_.orderFee.xAxis = ;
            _.chargeSum.thisData.push(item.chargeVal)
            //_.chargeSum.xAxis.push(item.chargeDay);
            _.orderNum.thisData.push(item.orderCount)
            //_.orderNum.xAxis.push(item.chargeDay);
            _.custNum.thisData.push(item.custCount)
            //_.custNum.xAxis.push(item.chargeDay);
          })
          res.data.data.rptChartMap.lastData.forEach((item, index) => {
            _.orderFee.lastData.push(item.actFee)
            _.chargeSum.lastData.push(item.chargeVal)
            _.orderNum.lastData.push(item.orderCount)
            _.custNum.lastData.push(item.custCount)
          })
          _.otherFlag = true
          _.$U.hideLoading(_)
        })
      } else {
        _.lineTitle = '本年度'
        _.lineData.dealerNo = _.$store.state.editId //'DEAL1543895439624'
        _.lineData.chartDateType = chartDateType
        _.$U.showLoading(_)
        _.otherFlag = false
        _.orderFee.thisData = []
        _.chargeSum.thisData = []
        _.orderNum.thisData = []
        _.orderFee.xAxis = [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ]
        _.chargeSum.xAxis = [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ]
        _.orderNum.xAxis = [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ]
        _.orderFee.lastData = []
        _.chargeSum.lastData = []
        _.orderNum.lastData = []
        _.custNum.thisData = []
        _.custNum.xAxis = [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ]
        _.custNum.lastData = []
        _.feeSum = ''
        _.chargeNum = ''
        _.orderSum = ''
        _.custSum = ''
        _.$H.post(_, _.$A.dealer.rptchart, _.lineData).then((res) => {
          _.feeSum = res.data.data.feeSum
          _.chargeNum = res.data.data.chargeSum
          _.orderSum = res.data.data.orderNum
          _.custSum = res.data.data.custNum
          res.data.data.rptChartMap.thisData.forEach((item, index) => {
            _.orderFee.thisData.push(item.actFee)
            //_.orderFee.xAxis.push(item.chargeDay);
            _.chargeSum.thisData.push(item.chargeVal)
            //_.chargeSum.xAxis.push(item.chargeDay);
            _.orderNum.thisData.push(item.orderCount)
            //_.orderNum.xAxis.push(item.chargeDay);
            _.custNum.thisData.push(item.custCount)
            //_.custNum.xAxis.push(item.chargeDay);
          })
          res.data.data.rptChartMap.lastData.forEach((item, index) => {
            _.orderFee.lastData.push(item.actFee)
            _.chargeSum.lastData.push(item.chargeVal)
            _.orderNum.lastData.push(item.orderCount)
            _.custNum.lastData.push(item.custCount)
          })
          _.otherFlag = true
          _.$U.hideLoading(_)
        })
      }
    },
    //选择合计订单  线上订单  线下订单
    getLineData() {
      let _ = this
      console.log(_.lineData.chartDateType)
      if (_.lineData.chartDateType == 7) {
        _.lineTitle = '近七日'
        _.lineData.dealerNo = _.$store.state.editId //'DEAL1543895439624'
        //_.lineData.chartDateType = chartDateType;
        _.$U.showLoading(_)
        _.otherFlag = false
        _.orderFee.thisData = []
        _.chargeSum.thisData = []
        _.orderNum.thisData = []
        _.orderFee.xAxis = []
        _.chargeSum.xAxis = []
        _.orderNum.xAxis = []
        _.orderFee.lastData = []
        _.chargeSum.lastData = []
        _.orderNum.lastData = []
        _.custNum.thisData = []
        _.custNum.xAxis = []
        _.custNum.lastData = []
        _.feeSum = ''
        _.chargeNum = ''
        _.orderSum = ''
        _.custSum = ''
        _.$H.post(_, _.$A.dealer.rptchart, _.lineData).then((res) => {
          _.feeSum = res.data.data.feeSum
          _.chargeNum = res.data.data.chargeSum
          _.orderSum = res.data.data.orderNum
          _.custSum = res.data.data.custNum
          res.data.data.rptChartMap.thisData.forEach((item, index) => {
            _.orderFee.thisData.push(item.actFee)
            _.orderFee.xAxis.push(item.chargeDay)
            _.chargeSum.thisData.push(item.chargeVal)
            _.chargeSum.xAxis.push(item.chargeDay)
            _.orderNum.thisData.push(item.orderCount)
            _.orderNum.xAxis.push(item.chargeDay)
            _.custNum.thisData.push(item.custCount)
            _.custNum.xAxis.push(item.chargeDay)
          })
          res.data.data.rptChartMap.lastData.forEach((item, index) => {
            _.orderFee.lastData.push(item.actFee)
            _.chargeSum.lastData.push(item.chargeVal)
            _.orderNum.lastData.push(item.orderCount)
            _.custNum.lastData.push(item.custCount)
          })
          _.otherFlag = true
          _.$U.hideLoading(_)
        })
      } else if (_.lineData.chartDateType == 30) {
        _.lineTitle = '本月'
        _.lineData.dealerNo = _.$store.state.editId //'DEAL1543895439624'
        //_.lineData.chartDateType = chartDateType;
        _.$U.showLoading(_)
        _.otherFlag = false
        _.orderFee.thisData = []
        _.chargeSum.thisData = []
        _.orderNum.thisData = []
        _.orderFee.xAxis = [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
        ]
        _.chargeSum.xAxis = [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
        ]
        _.orderNum.xAxis = [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
        ]
        _.orderFee.lastData = []
        _.chargeSum.lastData = []
        _.orderNum.lastData = []
        _.custNum.thisData = []
        _.custNum.xAxis = [
          1,
          2,
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          12,
          13,
          14,
          15,
          16,
          17,
          18,
          19,
          20,
          21,
          22,
          23,
          24,
          25,
          26,
          27,
          28,
          29,
          30,
          31,
        ]
        _.custNum.lastData = []
        _.feeSum = ''
        _.chargeNum = ''
        _.orderSum = ''
        _.custSum = ''
        _.$H.post(_, _.$A.dealer.rptchart, _.lineData).then((res) => {
          _.feeSum = res.data.data.feeSum
          _.chargeNum = res.data.data.chargeSum
          _.orderSum = res.data.data.orderNum
          _.custSum = res.data.data.custNum
          res.data.data.rptChartMap.thisData.forEach((item, index) => {
            _.orderFee.thisData.push(item.actFee)
            //_.orderFee.xAxis = ;
            _.chargeSum.thisData.push(item.chargeVal)
            //_.chargeSum.xAxis.push(item.chargeDay);
            _.orderNum.thisData.push(item.orderCount)
            //_.orderNum.xAxis.push(item.chargeDay);
            _.custNum.thisData.push(item.custCount)
            //_.custNum.xAxis.push(item.chargeDay);
          })
          res.data.data.rptChartMap.lastData.forEach((item, index) => {
            _.orderFee.lastData.push(item.actFee)
            _.chargeSum.lastData.push(item.chargeVal)
            _.orderNum.lastData.push(item.orderCount)
            _.custNum.lastData.push(item.custCount)
          })
          _.otherFlag = true
          _.$U.hideLoading(_)
        })
      } else {
        _.lineTitle = '本年度'
        _.lineData.dealerNo = _.$store.state.editId //'DEAL1543895439624'
        //_.lineData.chartDateType = chartDateType;
        _.$U.showLoading(_)
        _.otherFlag = false
        _.orderFee.thisData = []
        _.chargeSum.thisData = []
        _.orderNum.thisData = []
        _.orderFee.xAxis = [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ]
        _.chargeSum.xAxis = [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ]
        _.orderNum.xAxis = [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ]
        _.orderFee.lastData = []
        _.chargeSum.lastData = []
        _.orderNum.lastData = []
        _.custNum.thisData = []
        _.custNum.xAxis = [
          '1月',
          '2月',
          '3月',
          '4月',
          '5月',
          '6月',
          '7月',
          '8月',
          '9月',
          '10月',
          '11月',
          '12月',
        ]
        _.custNum.lastData = []
        _.feeSum = ''
        _.chargeNum = ''
        _.orderSum = ''
        _.custSum = ''
        _.$H.post(_, _.$A.dealer.rptchart, _.lineData).then((res) => {
          _.feeSum = res.data.data.feeSum
          _.chargeNum = res.data.data.chargeSum
          _.orderSum = res.data.data.orderNum
          _.custSum = res.data.data.custNum
          res.data.data.rptChartMap.thisData.forEach((item, index) => {
            _.orderFee.thisData.push(item.actFee)
            //_.orderFee.xAxis.push(item.chargeDay);
            _.chargeSum.thisData.push(item.chargeVal)
            //_.chargeSum.xAxis.push(item.chargeDay);
            _.orderNum.thisData.push(item.orderCount)
            //_.orderNum.xAxis.push(item.chargeDay);
            _.custNum.thisData.push(item.custCount)
            //_.custNum.xAxis.push(item.chargeDay);
          })
          res.data.data.rptChartMap.lastData.forEach((item, index) => {
            _.orderFee.lastData.push(item.actFee)
            _.chargeSum.lastData.push(item.chargeVal)
            _.orderNum.lastData.push(item.orderCount)
            _.custNum.lastData.push(item.custCount)
          })
          _.otherFlag = true
          _.$U.hideLoading(_)
        })
      }
    },
  },
  mounted() {
    this.init()
  },
}
</script>
